import { signInWithPopup, GithubAuthProvider } from 'firebase/auth';
import { auth } from './firebase';

const loginWithGithub = async () => {
  const provider = new GithubAuthProvider();
  try {
    await signInWithPopup(auth, provider);
  } catch (error) {
    console.error('GitHub login error:', error.message);
  }
};

export default loginWithGithub;
